export const getMessage = (message?: string) => {
  if (!message) {
    return 'Something went wrong'
  }
  if (message === 'Trouble with localStorage') {
    return (
      'You have modified browser permissions and it blocks the app. \n' +
      'On your computer, open Chrome.\n' +
      'At the top right, click More More and then Settings.\n' +
      'At the bottom, click Advanced.\n' +
      'Chromebook, Linux, and Mac: Under "Reset Settings," click Restore settings to their original defaults and then Reset Settings.\n' +
      'Windows: Under "Reset and cleanup,” click Reset Settings and then Reset Settings.'
    )
  }
  return message
}
